const routes = [
  {
    path: '/irpsu',
    name: 'irpsu',
    component: () => import('./views/index.vue'),
    meta: {
      layout: 'empty',
    },
  },
];
export default routes;
